import axios from "axios";

const loadForms = (callback) => {
    const config = {
        url: '/api/forms',
        method: 'GET',
    }

    axios.request(config).then(response => callback(response.data));
}

const getForm = (id, callback) => {
    const config = {
        url: `/api/forms/${id}`,
        method: 'GET',
    }

    axios.request(config).then(response => callback(response.data));
}

const deleteForm = (id, callback) => {
    const config = {
        url: `/api/forms/${id}`,
        method: 'DELETE',
    }

    axios.request(config).then(response => callback(response.data));
}

const save = (data, callback) => {
    const {id} = data
    const config = {
        url: id ? `/api/forms/${id}` : '/api/forms',
        method: id ? 'PUT' : 'POST',
        data: data,
    }

    axios.request(config).then(response => callback(response.data))
}

const FormActions = {
    loadForms,
    getForm,
    deleteForm,
    save
}

export default FormActions;